module.exports = __webpack_public_path__ + "static/the-geography-of-genius-6daf63522a1289e6cc0631b034ef1d87.jpg";